import { Clock3, FileText } from "lucide-react";

export default function AdminAnnualReturns() {
  return (
    <div
      className="min-h-[70vh] flex items-center justify-center"
      data-testid="admin-annual-returns-page"
    >
      <div className="sf-card max-w-xl w-full p-10 text-center">
        <div className="mx-auto mb-5 h-16 w-16 rounded-full bg-emerald-50 flex items-center justify-center">
          <FileText className="h-8 w-8 text-emerald-600" />
        </div>

        <h1 className="font-display text-2xl font-bold text-slate-900">
          Annual Fertilizer Return
        </h1>

        <div className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-full bg-amber-50 border border-amber-200 text-amber-700 font-semibold text-sm">
          <Clock3 className="h-4 w-4" />
          Coming Soon
        </div>

        <p className="text-sm text-slate-500 mt-5 leading-6">
          This feature is currently under development. The official
          government fertilizer return, automatic calculations, yearly
          statements and PDF generation will be available here soon.
        </p>

        <p className="text-xs text-slate-400 mt-4">
          The feature will be enabled after final testing.
        </p>
      </div>
    </div>
  );
}
